import {
  Text,
  Stack,
  HStack,
  Box,
  Tooltip,
  Icon,
  Flex,
} from "@chakra-ui/react";
import { textSecondary, textPrimary, color8 } from "../../../../utils/colors";
import { TbDental } from "react-icons/tb";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsDesktop = (
  slug,
  dispatch,
  translate,
  handleSortChange,
  updateServiceStatus,
  setShowDeleteConfirmation,
  setServiceId,
  setServiceName,
  setIsInPlans,
  openEditSidePanelModal,
  currencySymbol,
  hasAccessToEdit
) => {
  return [
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      width: 420,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        // console.log("handleSortChange", handleSortChange);

        return (
          <HStack gap={2}>
            <Stack gap={0}>
              <Text
                fontSize="15px"
                color={textPrimary}
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxWidth="360px"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("price")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnPrice")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "price",
      width: 160,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { price, priceRange, maxPrice, priceVariations } = row.original;

        // console.log("row.original", row.original);

        return (
          <>
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              fontSize="xs"
              label={translate("tooltip.priceVariations")}
              placement="top"
              isDisabled={!priceVariations}
            >
              <Flex align="center">
                {priceVariations && (
                  // <Icon
                  //   mr={1.5}
                  //   as={FaCircleInfo}
                  //   w="initial"
                  //   h="0.875rem"
                  //   color={backgroundGrey}
                  // />
                  <Icon
                    as={TbDental}
                    color={color8}
                    fontSize="0.875rem"
                    mr={1.5}
                  />
                )}
                {!priceRange ? (
                  <Text fontSize="sm" color={textSecondary} fontWeight="500">
                    {currencySymbol} {price}
                  </Text>
                ) : (
                  <Text fontSize="sm" color={textSecondary} fontWeight="500">
                    {currencySymbol} {price} - {currencySymbol} {maxPrice}
                  </Text>
                )}
              </Flex>
            </Tooltip>
          </>
        );
      },
    },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("duration")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnDuration")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "duration",
      width: 120,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { duration } = row.original;

        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration - hours * 3600) / 60);
        const seconds = duration - hours * 3600 - minutes * 60;

        let formattedDuration = "";
        if (hours > 0) formattedDuration += `${hours}h `;
        if (minutes > 0) formattedDuration += `${minutes}min `;
        if (seconds > 0) formattedDuration += `${seconds}s`;

        return (
          <Text
            fontSize="sm"
            color={textSecondary}
            fontWeight="500"
            textAlign="left"
          >
            {formattedDuration.trim() || "-"}
          </Text>
        );
      },
    },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("serviceGroup")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnServiceGroup")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "serviceGroup",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { serviceGroup } = row.original;

        const name = serviceGroup ? serviceGroup.name : "";

        // console.log("serviceGroup", serviceGroup);
        return (
          <Text
            fontSize="sm"
            color={textSecondary}
            fontWeight="500"
            textAlign="left"
            isTruncated
            maxW="160px"
          >
            {name}
          </Text>
        );
      },
    },
    // {
    //   Header: translate("service.columnServices"),
    //   accessor: (row) => {
    //     console.log("row", row);

    //     return (
    //       <Text fontSize="sm" color={textSecondary} fontWeight="500">
    //         {/* {services.length} */}
    //       </Text>
    //     );
    //   },
    // },
    // {
    //   Header: translate("service.columnCustomId"),
    //   accessor: "customId", // Use the key directly for sorting
    //   Cell: (
    //     { value } // Define how to render the cell
    //   ) => (
    //     <Text
    //       overflow="hidden"
    //       whiteSpace="nowrap"
    //       fontSize="sm"
    //       color={textSecondary}
    //       fontWeight="500"
    //     >
    //       {value}
    //     </Text>
    //   ),
    // },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id, inPlans } = row.original;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateServiceStatus(slug, _id, newStatus));
        };

        // console.log("inPlans", inPlans);

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              p="0 2.5rem"
              isUnclickable={!hasAccessToEdit}
            />
            {/* <StatusButton
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="active"
              isUnclickable={!isAdmin}
            /> */}

            <MoreButtonLite
              id={_id}
              viewHandler={() => {
                setServiceId(_id); // Set the user ID for editing
                openEditSidePanelModal();
              }}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setServiceId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setIsInPlans(inPlans);
                setServiceName(row.original.name);
              }}
            />

            {/* <MoreButton
              id={_id}
              deleteHandler={deleteServiceHandler}
              deleteButtonDisabled={!isAdmin}
              editHandler={(e) => {
                e.stopPropagation();
                openEditSidePanelModal(_id);
              }}
              editButtonDisabled={!isAdmin}
            /> */}
          </HStack>
        );
      },
    },
  ];
};
